import React, { useEffect, useState } from 'react';
import DashboardLayout from './DashboardLayout';
import { showingService } from '../../_services/showing.service';

function Stars({ n }) {
  return (
    <span className="rv-stars">
      {[1, 2, 3, 4, 5].map(i => <span key={i} className={i <= n ? '' : 'off'}>★</span>)}
    </span>
  );
}

function ReviewList({ items, who }) {
  if (!items.length) return <div className="sh-empty" style={{ padding: '30px 10px' }}>No reviews here yet.</div>;
  return (
    <div className="sh-list">
      {items.map(r => (
        <div className="rv-card" key={r._id}>
          <div className="rv-head">
            <span className="rv-name">{who === 'received' ? r.reviewer.name : r.reviewee.name}</span>
            <span className="rv-date">{new Date(r.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
          </div>
          <Stars n={r.rating} />
          {r.comment ? <p>{r.comment}</p> : null}
          <div className="db-td-sub" style={{ marginTop: 6 }}>Showing #{r.request_id.slice(0, 8)} · {r.direction === 'buyer_to_agent' ? 'as showing agent' : 'as requesting agent'}</div>
        </div>
      ))}
    </div>
  );
}

export default function Reviews() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState('received');

  useEffect(() => {
    showingService.myReviews().then(res => {
      if (res.status === 'success') setData(res);
      else setError(res.message || 'Could not load reviews.');
    }).catch(() => setError('Could not load reviews.'));
  }, []);

  return (
    <DashboardLayout>
      <h1>Reviews</h1>
      <p className="sh-page-sub">Ratings exchanged after completed showings. Your average appears on your profile and next to your name on jobs.</p>

      <div className="sh-tabs">
        <button className={'sh-tab' + (tab === 'received' ? ' active' : '')} onClick={() => setTab('received')}>
          Received {data ? `(${data.received.length})` : ''}
        </button>
        <button className={'sh-tab' + (tab === 'given' ? ' active' : '')} onClick={() => setTab('given')}>
          Given {data ? `(${data.given.length})` : ''}
        </button>
      </div>

      {error ? (
        <div className="sh-error" style={{ margin: '18px 0' }}>{error}</div>
      ) : data === null ? (
        <div className="sh-empty">Loading…</div>
      ) : (
        <ReviewList items={tab === 'received' ? data.received : data.given} who={tab} />
      )}
    </DashboardLayout>
  );
}
